import React from 'react';
import Routes from "./routes";

const App = () => {
  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;
